<template>

  <section
    v-if="variants.v1 === variant"
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor});`"
  >
    <div class="tw-w-full tw-overflow-hidden">
      <h2 class="text-animation tw-text-start tw-uppercase">
        <span ref="animatedSpan" class="animated-title">
          {{ vars.part1Text }} &nbsp;{{ vars.part2Text }} <br />{{ vars.part3Text }}
        </span>
      </h2>
    </div>
  </section>

 
  <section
    v-if="variants.v2 === variant"
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor});`"
  >
    <div class="tw-w-full tw-overflow-hidden">
      <h2 class="text-animation tw-text-start tw-uppercase tw-relative">
  
        <span class="title-base">
          {{ vars.part1Text }} &nbsp;{{ vars.part2Text }} <br />{{ vars.part3Text }}
        </span>
       
        <span
          ref="animatedSpanV2"
          class="title-overlay"
          aria-hidden="true"
        >
          {{ vars.part1Text }} &nbsp;{{ vars.part2Text }} <br />{{ vars.part3Text }}
        </span>
      </h2>
    </div>
  </section>
</template>

<script lang="ts">
import { useWindowSize } from '@vueuse/core';
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'ScrollAnimationTextsTheme6',
  mixins: [ComponentMixin],

  data() {
    return {
      variants: { v1: 'v1', v2: 'v2' },
      _raf: 0 as number,
    };
  },

  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.$nextTick(() => this.onScroll()); // ilk konumu hesapla
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    if (this._raf) cancelAnimationFrame(this._raf);
  },

  methods: {
    onScroll() {

      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = requestAnimationFrame(this.revealSpans);
    },

    revealSpans() {
      const { height } = useWindowSize();

 
      if (this.variant === this.variants.v1) {
        const el = this.$refs.animatedSpan as HTMLElement | undefined;
        if (el) this.applyReveal(el, height.value);
      }


      if (this.variant === this.variants.v2) {
        const overlay = this.$refs.animatedSpanV2 as HTMLElement | undefined;
        if (overlay) this.applyReveal(overlay, height.value);
      }
    },

    applyReveal(el: HTMLElement, viewportH: number) {
      const triggerDistance = viewportH * 0.85;


      let y = el.offsetTop;
      let p = el.offsetParent as HTMLElement | null;
      while (p) {
        y += p.offsetTop;
        p = p.offsetParent as HTMLElement | null;
      }

      const distanceFromViewportTop = y - window.pageYOffset;

 
      let percent = 1 - (Math.max(distanceFromViewportTop, 0) - triggerDistance) / 5;
      percent = Math.min(Math.max(percent, 0), 100);

  
      el.style.backgroundSize = `${percent}% 100%`;
      el.style.setProperty('--reveal', `${percent}% 100%`);
    },
  },
});
</script>

<style scoped>

@keyframes reveal {
  from { opacity: 0; clip-path: inset(45% 20% 45% 20%); }
  to   { opacity: 1; clip-path: inset(0% 0% 0% 0%); }
}
.text-animation {
  animation: linear reveal both;
  animation-timeline: view();
  animation-range: entry 25% cover 50%;
}
span.animated-title {
  font-family: var(--f-primary) !important;
  color: var(--c-secondary-rgba) !important;
  background-clip: text;
  -webkit-background-clip: text;
  background-repeat: no-repeat;
  background-image: linear-gradient(90deg, var(--c-primary), var(--c-primary));
}


.text-animation { position: relative; }

.title-base {
  font-family: var(--f-primary) !important;
  color: #000 !important; 
  white-space: pre-wrap;
}

.title-overlay {
  position: absolute;
  inset: 0;
  font-family: var(--f-primary) !important;
  pointer-events: none;      
  white-space: pre-wrap;     
  z-index: 1;


  color: transparent !important;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  -webkit-background-clip: text;


  background-image: linear-gradient(90deg, var(--c-primary), var(--c-primary));
  background-repeat: no-repeat;
  background-position: left center;
  background-size: var(--reveal, 0% 100%); 
}
</style>
